import { render, staticRenderFns } from "./JournalTaskLine.vue?vue&type=template&id=a537772a"
import script from "./JournalTaskLine.vue?vue&type=script&lang=ts"
export * from "./JournalTaskLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports